// Shared field-keyed compare for useAgents selectors that `pick()` a fresh
// object per agent. zustand/shallow is element-wise Object.is, so it never
// holds over those arrays. Per rule: think-in-systems (ai.knowledge/global).

export const signalAgentPick = ['id', 'embedded', 'lastShutDownAt', 'status'] as const;

export const placeholderAgentPick = ['id', 'name', 'version', 'status'] as const;

export const idNamePick = ['id', 'name'] as const;

export const idNameStatusPick = ['id', 'name', 'status'] as const;

export const watchdogAgentPick = ['embedded', 'id', 'name', 'status'] as const;

export const recordsShallowEqual = (
  left: Record<string, unknown>,
  right: Record<string, unknown>
): boolean => {
  const keys = Object.keys(left);

  return keys.length === Object.keys(right).length && keys.every((key) => left[key] === right[key]);
};

export type SignalAgentSlice = {
  readonly embedded?: boolean;
  readonly id?: string;
  readonly lastShutDownAt?: Date;
  readonly status?: string;
};

export type PlaceholderAgentSlice = {
  readonly id?: string;
  readonly name?: string;
  readonly status?: string;
  readonly version?: string;
};

export const fieldKeyedAgentsEqual = <T extends object>(
  left: readonly T[],
  right: readonly T[],
  keys: readonly (keyof T)[]
): boolean =>
  left.length === right.length &&
  left.every((item, index) => {
    const other = right[index];
    if (other === undefined) {
      return false;
    }

    return keys.every((key) => item[key] === other[key]);
  });

// Same formula Signal already used: a defined lastShutDownAt whose numeric
// value is less than 5s ahead of `now` waits 5s, otherwise 0. Extracted so
// tests hit production, not a copy. Per rule: ai-code-requires-tests.
export const idleRestartDelayMs = (lastShutDownAt: unknown, now = Date.now()): number =>
  lastShutDownAt !== undefined && Number(lastShutDownAt) - now < 5000 ? 5e3 : 0;
